<div class="topline">
  <h2>Claimed Rewards</h2>
  <button mat-raised-button color="primary" (click)="addClaimed()">Add Claimed Reward</button>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Created At</th>
      <td mat-cell *matCellDef="let claimed">{{claimed.createdAt | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let claimed">{{claimed.status}}</td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>User</th>
      <td mat-cell *matCellDef="let claimed">{{userCache[claimed.userId]}}</td>
    </ng-container>

    <ng-container matColumnDef="taskGoal">
      <th mat-header-cell *matHeaderCellDef>Task/Goal</th>
      <td mat-cell *matCellDef="let claimed">{{goalTaskCache[claimed.taskId || claimed.goalId]}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let claimed">
        <button
          mat-icon-button
          class="snowman-menu-trigger"
          [matMenuTriggerFor]="claimedActionsMenu"
          [matMenuTriggerData]="{ claimed: claimed }"
          (click)="$event.stopPropagation()"
          aria-label="Claimed reward actions"
          >
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (click)="editClaimed(row)"></tr>
  </table>

  @if (loading) {
    <div class="loading">Loading...</div>
  }
  @if (!loading && items.length === 0) {
    <div class="empty">There are no snacks/rewards to show.</div>
  }
</div>

<mat-menu #claimedActionsMenu="matMenu">
  <ng-template matMenuContent let-claimed="claimed">
    <button mat-menu-item (click)="$event.stopPropagation(); editClaimed(claimed)">Edit claimed reward</button>
    <button mat-menu-item (click)="cycleStatus($event, claimed)">Cycle status</button>
    <button mat-menu-item (click)="deleteClaimed($event, claimed)">Delete claimed reward</button>
  </ng-template>
</mat-menu>
